import { render, staticRenderFns } from "./TimelineSocialTagboard.vue?vue&type=template&id=de7cba1a"
import script from "./TimelineSocialTagboard.vue?vue&type=script&lang=js"
export * from "./TimelineSocialTagboard.vue?vue&type=script&lang=js"
import style0 from "./TimelineSocialTagboard.vue?vue&type=style&index=0&id=de7cba1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports